// if this all works out, move to core components when done

import { LitElement, html, css } from 'lit-element';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
// import './tmn-table-simple';
import { TmnTableSelectable } from './tmn-table-selectable';

import { DETAIL_MODES } from './table-constants';

export class TmnTableEditable extends TmnTableSelectable {
    constructor() {
        super();
        this.selectedRowIds = [];
        this.detailMode = DETAIL_MODES.VIEW;
        this.canShowDetailsPanel = true;
        this.canAddNew = true;
        this.searchString = '';
        this.confirmMessage = 'Are you sure?';
        this.showConfirmCloseDialog = false;
        this.newButtonLabel = 'New';
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    /* max-width: 1200px; */
                    /* --table-cell-height: 37px; */
                }
                .detail-panel {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    padding: 0 4px 10px 0;
                    border-radius: 20px;
                    margin-left: 12px;
                    margin-bottom: 12px;
                    background-color: var(--app-surface-color);
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    border-left: 0;
                }
                .detail-panel tmn-icon-button {
                    position: sticky;
                    top: 6px;
                    margin-top: 6px;
                    /* right: 4px; */
                    z-index: 2;
                }

                tmn-button[name='new'] {
                    min-width: 100px;
                    margin: 10px 8px;
                }

                .scroller > table {
                    --tmn-table-min-width: 0;
                }
            `,
        ];
    }

    static get properties() {
        return {
            detailMode: {
                type: String,
            },
            canShowDetailsPanel: {
                type: Boolean,
            },
            canAddNew: {
                type: Boolean,
            },
            shouldConfirmOnClose: {
                type: Boolean,
            },
            showConfirmCloseDialog: {
                type: Boolean,
            },
            newButtonLabel: {
                type: String,
            },
        };
    }

    getColumnDefs() {
        const isDetailPanelActive = this.shouldShowDetailsPanel();
        const baseColumnDefs = super.getColumnDefs();
        return baseColumnDefs.map((d, idx) => {
            return {
                ...d,
                hidden: d.hidden || (isDetailPanelActive && d.hideInDetailMode),
            };
        });
    }

    //override base
    render() {
        return html`${this.renderTopBar()}
            <div class="main-panel">
                ${this.renderDialogs()} ${this.renderFilterPanel()} ${this.renderScrollableTable()}
                ${this.renderDetails()}
            </div>`;
    }
    renderScrollableTable() {
        //const hideScroller = this.shouldShowDetailsPanel() &&
        return html`<div class="scroller">${this.renderTable()}</div>`;
    }

    renderDetails() {
        if (this.shouldShowDetailsPanel()) {
            return html`<div class="detail-panel scroller">
                <div>
                    <slot name="detail"></slot>
                </div>
                <tmn-icon-button @click=${this.handleClose}>
                    <tmn-icon icon="close"></tmn-icon
                ></tmn-icon-button>
            </div>`;
        }
    }

    renderDialogs() {
        return html`${this.renderNaviagationConfirmationDialog()}${this.renderCloseConfirmationDialog()}`;
    }

    renderCloseConfirmationDialog() {
        // todo in the future, would it be possible to use a slot to allow something like  "save to continue?"
        // to be passsed down to here?
        const { showConfirmCloseDialog, confirmMessage } = this;
        return html`<table-action-confirmation
            @tmn-action-confirmed=${this.closeDetails}
            @tmn-tool-closed=${this.resetCloseDialog}
            .confirmMessage=${confirmMessage}
            .open=${showConfirmCloseDialog}></table-action-confirmation>`;
    }

    resetCloseDialog() {
        this.showConfirmCloseDialog = false;
        this.pendingEventData = null;
    }
    // todo maybe just use the slot?
    renderRightTopActions() {
        const { canAddNew, newButtonLabel } = this;

        return html`${this.isAddNewMode()
            ? null
            : html`<slot name="right-actions"></slot>
                  ${canAddNew
                      ? html`<tmn-button
                            color="primary"
                            name="new"
                            variant="contained"
                            @click=${this.handleNew}>
                            ${newButtonLabel}
                        </tmn-button>`
                      : null} `}`;
    }

    selectRow(id) {
        super.selectRow(id);
        // todo when do we want to do this? maybe not always?
        // todo also need to do this on route change (i.e. when we click a link in the table)
        // maybe that one can operate on content based on a routing hook or we can work through the table
        // or do it directly on the formatter?
        // one other useful feature would be to move the selected rows to the top
        if (this.shouldShowDetailsPanel()) {
            requestAnimationFrame(() => {
                const panel = this.shadowRoot.querySelector('.top-bar');
                panel.scrollIntoView({
                    behavior: 'instant',
                });
            });
        }
    }

    shouldShowDetailsPanel() {
        const { canShowDetailsPanel, selectedRowIds } = this;
        if (!canShowDetailsPanel) {
            return false;
        }

        if (this.isAddNewMode()) {
            return true;
        }
        if (selectedRowIds?.length) {
            return true;
        }
    }

    handleNew(e) {
        const event = new CustomEvent('tmn-table-editable-add-new', {
            detail: {},
            bubbles: true,
            composed: true,
        });

        this.dispatchEvent(event);
    }

    handleClose() {
        const { shouldConfirmOnClose } = this;
        if (shouldConfirmOnClose) {
            this.showConfirmCloseDialog = true;
            return;
        }

        this.closeDetails();
    }

    closeDetails() {
        const event = new CustomEvent('tmn-table-editable-close-details', {
            detail: {},
            bubbles: true,
            composed: true,
        });

        this.dispatchEvent(event);
    }

    isViewMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.VIEW;
    }

    isAddNewMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.NEW;
    }

    isEditMode() {
        const { detailMode } = this;
        return detailMode === DETAIL_MODES.EDIT;
    }
}

window.customElements.define('tmn-table-editable', TmnTableEditable);

// add new multi-select-detail panel slot

// todo resolve this stuff
// renderTopBar() {
//     const { multiSelectStatus, searchString, selectedRowIds, selectMode } = this;
//     if (multiSelectStatus !== MULTI_SELECT_STATUS.NONE) {
//         return html`<div class="top-bar multi-action-bar">
//             <tmn-grid container spacing="0" alignItems="center" wrap="nowrap">
//                 ${this.renderMultiSelectCheckBox()}
//                 <tmn-grid container item sm="auto">
//                     <span>${selectedRowIds?.length} selected</span>
//                 </tmn-grid>
//                 <tmn-grid container item sm="" justify="flex-end"> </tmn-grid>
//             </tmn-grid>
//         </div>`;
//     }
//     const showMultiSelect = selectMode === SELECT_MODES.MULTI;
//     // show multiselect is just a temp option to turn this off
//     // TODO the "filters" section should really be baked into the columns of the table, for now just
//     // quick and dirty to be able to filter inactives
//     return html`<div class="top-bar">
//         <tmn-grid container spacing="0" alignItems="center" wrap="nowrap">
//             ${showMultiSelect
//                 ? html`<tmn-grid item sm="1"
//                       ><tmn-icon-button variant="text" @click="${this.handleToggleAllSelected}">
//                           <tmn-icon icon="check_box_outline_blank"></tmn-icon> </tmn-icon-button
//                   ></tmn-grid>`
//                 : null}

//             <tmn-grid container item sm="auto">
//                 <tmn-input
//                     .value=${searchString}
//                     placeholder="${localize('search')}"
//                     @tmn-input-changed=${this._handleSearchStringChanged}></tmn-input>
//             </tmn-grid>
//             <tmn-grid item sm="3" container justify="center"
//                 ><slot name="filters"></slot>
//             </tmn-grid>
//             <tmn-grid container item sm="2" justify="flex-end"> </tmn-grid>
//         </tmn-grid>
//     </div>`;
// }
